import type { ReactElement } from "react";

import { FormSelect } from "app/pages/sales-intelligence/common-components/form-fields";
import { signalsPerHook } from "app/pages/sales-intelligence/modules/signals-api-webhook/constants/signals-per-hook";
import type { IWebhookTableCellProps } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/cell-props";

import { StyledWebhookTableCellWrapper } from "../styles";

const SignalsPerHookCell = ({ value, name, index, onChange }: IWebhookTableCellProps<number>): ReactElement => {
    const handleValueChange = (newValue: number) => {
        if (newValue === value) {
            return;
        }

        onChange(index, name, newValue);
    };

    return (
        <StyledWebhookTableCellWrapper>
            <FormSelect<number>
                fieldName={`updateDateRangeType-${index}`}
                dropdownPopupPlacement="bottom"
                value={value}
                options={signalsPerHook}
                formatValue={(option) => String(option)}
                onChange={handleValueChange}
            />
        </StyledWebhookTableCellWrapper>
    );
};

export default SignalsPerHookCell;
